import React from 'react';
import { Badge } from '@shopify/polaris';
import { withI18n } from '@shopify/react-i18n';
import { ReactNode } from 'react';
import RenderUnlockBanner from 'src/components/views/synonym/render-unlock-banner';
import SearchPersonalizationPresentBanner from 'src/components/views/advanced-search/search-personalization-present-banner';
import MarketingCampaignBanner from 'src/components/views/common/marketingCampaignBanner';
import FlatIcon from 'src/assets/images/common/flat-linear-icon.png';

interface Tabs {
  id: string;
  content: string;
  isBeta: boolean;
  [props: string]: any;
}
interface VerticalTabProps {
  tabs: Tabs[];
  children: ReactNode;
  selectedId: string;
  onSelected: (id: string) => void;
}
const VerticalTab = (props: VerticalTabProps) => {
  const { i18n, tabs, children, selectedId, onSelected, scope = 'standard' } = props;
  return (
    <div className="BC_VerticalTab_Wrapper">
      <div className="tab-items">
        {tabs.map((tab, index) => {
          const { id: tabId, content, isBeta, isAI, ...props } = tab;
          return (
            <div
              key={`tab-${index}`}
              className={`${tabId === selectedId ? 'tab-selected' : ''}`}
              onClick={() => tabId !== selectedId && onSelected(tabId)}>
              <div className="tab-item" {...props}>
                <span className="tab-name">{content}</span>
                {isBeta && <Badge>{i18n.translate('AdminHTML.Common.Badge.beta')}</Badge>}
                {isAI && (
                  <div className="badge-ai">
                    <Badge>
                      <img width={14} height={14} src={FlatIcon} alt="wand" />
                    </Badge>
                  </div>
                )}
              </div>
            </div>
          );
        })}
        {scope === 'standard' && (
          <MarketingCampaignBanner
            page="StandardSearch"
            type="vertical"
            showWhenDismissed={
              <SearchPersonalizationPresentBanner
                type="vertical"
                page="StandardSearch"
                showWhenDismissed={<RenderUnlockBanner selectedId={selectedId} />}
              />
            }
          />
        )}
        {scope === 'advanced' && (
          <MarketingCampaignBanner page="AdvancedSearch" type="vertical" showWhenDismissed="" />
        )}
      </div>

      <div className="tab-children">{children}</div>
    </div>
  );
};

export default withI18n()(VerticalTab);
